import { configureStore } from "@reduxjs/toolkit";
import signupReducer from "./signupSlice";
import otpVerificationReducer from "./OtpSlice";
import createProjectReducer from "./CreateProjectSlice";
import getProjectListReducer from "./GetProjectListSlice";
import chatHistoryReducer from "./GetChatHistorySlice";
import askQuestionReducer from "./AskQuestionSlice";
import googleLoginReducer from "./GoogleSignInSlice";
import facebookLoginReducer from "./FacebookSignInSlice";
import uploadFileReducer from "./PdfUploadApiSlice";
import fileUploadReducer from "./fileUploadSlice";
import askQuestionFromPdfReducer from "./AskQuestionFromPdfSlice";
import getDocumentListReducer from "./GetDocumentListSlice";
import userReducer from "./userSlice";
import getCountryListReducer from "./GetCountrySlice";
import getStateListReducer from "./GetStateListSlice";
import getCityListReducer from "./GetCityListSlice";
import createCompanyReducer from "./CreateCompanySlice";
import getCompanyListReducer from "./GetCompanyListSlice";
import getProfileReducer from "./GetProfileSlice";
import editProfileReducer from "./EditProfileSlice";
import getProjectReducer from "./GetProjectSlice";
import updateProjectReducer from "./UpdateProjectSlice";
import DeleteFileReducer from "./DeleteFileSlice";
import getGoogleDriveoAuthUrlReducer from "./GetGoogleoAuthUrlSlice"
import getGoogleDriveAccessTokenReducer from "./GetgoogleDriveAccessTokenSlice"
import revokeGoogleDrivePermissionSliceReducer from "./RevokeGoogleDrivePermissionSlice"

import getOneDriveAccessTokenReducer from "./GetOneDriveAccessTokenSlice"
import revokeOneDrivePermissionSliceReducer from "./RevokeOneDrivePermissionSlice"
import getQuestinDetail from "./GetQuestionDetailsSlice"

import employeeReducer  from "./employeeSlice";
import subscriptionPlanReducer from './subscriptionSlice'
import profileActivityReducer from './getProfileActivitySlice'
import intakeAnswerReducer from './IntakeAnswerSlice'


import clinicalReviewReducer from './clinicalReviewSlice';
import uploadSurveyPdfReducer from './UploadSurveyPdfSlice';
import patientReducer from './PatientSlice';
import assessmentSessionReducer from './AssessmentSessionSlice';

const store = configureStore({
  reducer: {
    signupReducer: signupReducer,
    otpVerificationReducer: otpVerificationReducer,
    createProjectReducer: createProjectReducer,
    getProjectListReducer: getProjectListReducer,
    chatHistoryReducer: chatHistoryReducer,
    askQuestionReducer: askQuestionReducer,
    askQuestionFromPdfReducer: askQuestionFromPdfReducer,
    googleLoginReducer: googleLoginReducer,
    facebookLoginReducer: facebookLoginReducer,
    uploadFileReducer: uploadFileReducer,
    fileUpload: fileUploadReducer,
    getDocumentListReducer: getDocumentListReducer,
    userReducer: userReducer,
    getCountryListReducer: getCountryListReducer,
    getStateListReducer: getStateListReducer,
    getCityListReducer: getCityListReducer,
    createCompanyReducer: createCompanyReducer,
    getCompanyListReducer: getCompanyListReducer,
    getProfileReducer: getProfileReducer,
    editProfileReducer: editProfileReducer,
    getProjectReducer: getProjectReducer,
    updateProjectReducer: updateProjectReducer,
    DeleteFileReducer: DeleteFileReducer,
    getGoogleDriveoAuthUrlReducer: getGoogleDriveoAuthUrlReducer,
    getGoogleDriveAccessTokenReducer: getGoogleDriveAccessTokenReducer,
    revokeGoogleDrivePermissionSliceReducer: revokeGoogleDrivePermissionSliceReducer,
    getOneDriveAccessTokenReducer: getOneDriveAccessTokenReducer,
    revokeOneDrivePermissionSliceReducer: revokeOneDrivePermissionSliceReducer,
    getQuestinDetail: getQuestinDetail,
    employee : employeeReducer ,
    subscriptionPlan: subscriptionPlanReducer,
    profileActivity: profileActivityReducer,
    intakeAnswer: intakeAnswerReducer,
    clinicalReview: clinicalReviewReducer,
    uploadSurveyPdf: uploadSurveyPdfReducer,
    patients: patientReducer,
    assessmentSessions: assessmentSessionReducer,
  },
});

export default store;